<template>
  <!-- The stock pictures are squares with the round avatar inside: the circle crop shows just that -->
  <img v-if="src" :src="src" alt="" class="rounded-full object-cover bg-white" />
  <span v-else class="rounded-full inline-flex items-center justify-center bg-brand-100 text-brand-800 font-semibold">
    {{ initials }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { avatarSrc } from '@/composables/useAvatars'

const props = defineProps({
  user: { type: Object, default: null },
})

const src = computed(() => avatarSrc(props.user))
const initials = computed(() => {
  const u = props.user || {}
  const letters = `${u.first_name?.[0] || ''}${u.last_name?.[0] || ''}`
  return (letters || u.email?.[0] || '?').toUpperCase()
})
</script>
